import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import en from "lang/locales/lang.en.json";
import ko from "lang/locales/lang.ko.json";

/**
 * 파일명: i18n.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: 언어팩
 */
const resource = {
  en: {
    translation: en,
  },
  "en-US": {
    translation: en,
  },
  ko: {
    translation: ko,
  },
};

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    resources: resource,
    fallbackLng: {
      en: ["en"],
      "en-US": ["en"],
      default: ["ko"],
    },
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
    },
    react: {
      bindI18n: "languageChanged",
      bindI18nStore: "",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
      useSuspense: false,
    },
  });

export default i18n;
